/**
 * annonces.js
 * -----------
 * Annonces d'etablissement : redaction, diffusion, retrait.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── Annonces d'établissement ── */

/** GET /directeur/annonces/ -> { annonces, priorites, statuts, roles, classes, plafond } */
export async function getAnnonces(params = {}) {
  const { data } = await axiosClient.get("/directeur/annonces/", { params });
  return data || {};
}

/** POST /directeur/annonces/ — crée un brouillon (ou une annonce programmée). */
export async function creerAnnonce(payload) {
  const { data } = await axiosClient.post("/directeur/annonces/", payload);
  return data;
}

/** PATCH /directeur/annonces/<id>/ — modifie un brouillon. */
export async function modifierAnnonce(id, payload) {
  const { data } = await axiosClient.patch(`/directeur/annonces/${id}/`, payload);
  return data;
}

/** DELETE /directeur/annonces/<id>/ */
export async function supprimerAnnonce(id) {
  await axiosClient.delete(`/directeur/annonces/${id}/`);
}

/** POST /directeur/annonces/<id>/publier/ -> { annonce, envoyes } */
export async function publierAnnonce(id) {
  const { data } = await axiosClient.post(`/directeur/annonces/${id}/publier/`, {});
  return data;
}

/** POST /directeur/annonces/<id>/retirer/ -> { annonce, retires, deja_lus } */
export async function retirerAnnonce(id) {
  const { data } = await axiosClient.post(`/directeur/annonces/${id}/retirer/`, {});
  return data;
}
